import axios, {AxiosInstance} from 'axios';
import {STBBS_AFREECATV_DOMAIN} from 'constants/config';

const client: AxiosInstance = axios.create();
client.defaults.baseURL = `${STBBS_AFREECATV_DOMAIN}`;
client.defaults.withCredentials = true;
client.defaults.xsrfCookieName = undefined; // xsrf사용안함
client.defaults.xsrfHeaderName = undefined; // xsrf사용안함
client.defaults.headers.post['Content-Type'] =
  'application/x-www-form-urlencoded';

export default client;
